import termsES from './markdown/vouchers/minecraft/termsES.md?raw'
import termsTicketboxES from './markdown/vouchers/ticketbox/termsES.md?raw'
import termsPaddockES from './markdown/vouchers/paddock/termsES.md?raw'

export default {
  routes: {
    restaurants: 'restaurantes',
    ecommerceHome: 'pedidos',
    cart: 'carrito',
    staticMenu: {
      linkTitle: 'Productos',
      slug: 'menu',
    },
    checkout: 'checkout',
    profile: 'mi-cuenta',
    personalData: 'datos-personales',
    orders: 'mis-pedidos',
    signInSecurity: 'inicio-sesion-y-seguridad',
    myDevices: 'mis-dispositivos',
    mySavedAddresses: 'mis-direcciones-guardadas',
    downloadApp: 'descarga_app',
  },
  auth: {
    login: 'Iniciar sesión',
    register: 'Registrarme',
    logOnTo: 'Entrar',
  },
  footer: {
    legalBrand: {
      cookiePreferences: 'Preferencias de Cookies',
    },
  },
  common: {
    seeAll: 'Ver todo',
    priceFrom: 'Desde ',
    netAmountInfo: 'Precio sin impuestos nacionales: {price}',
    seeMore: 'Ver más',
    and: 'y',
    continue: 'Continuar',
    return: 'Volver',
    accept: 'Aceptar',
    edit: 'Editar',
    MOP: 'Pickup',
    DLV: 'McDelivery',
    seeDetail: 'Ver detalles',
    startOrder: 'Comenzar pedido',
    start: 'Seleccionar',
    alertAccept: 'Entendido',
    mon: 'Lunes',
    tue: 'Martes',
    wed: 'Miércoles',
    thu: 'Jueves',
    fri: 'Viernes',
    sat: 'Sábado',
    sun: 'Domingo',
    areas: {
      curb: 'En estacionamiento',
      aut: 'AutoMac',
      ealm: 'En la mesa',
      mop: 'En mostrador',
      dlv: 'McDelivery',
    },
    time: {
      hour: 'hora',
      hours: 'horas',
      minute: 'minuto',
      minutes: 'minutos',
      second: 'segundo',
      seconds: 'segundos',
    },
    timeAbbreviation: {
      days: 'Días',
      hours: 'Horas',
      minutes: 'Min.',
      seconds: 'Seg.',
    },
    toast: {
      clipboard: 'Copiado al portapapeles',
    },
    o: 'o',
    freeShippingLabel: 'Envío gratis',
    free: 'Gratis',
    offer: 'Oferta',
    product: 'producto | productos',
    privacyPolicy: 'Política de Privacidad',
    calendar: {
      monthNames: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      monthNamesShort: [
        'Ene',
        'Feb',
        'Mar',
        'Abr',
        'May',
        'Jun',
        'Jul',
        'Ago',
        'Sep',
        'Oct',
        'Nov',
        'Dic',
      ],
      dayNamesMin: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    },
    faqsBySection: {
      title: 'Preguntas frecuentes',
      messageNotData: 'No hay preguntas disponibles',
    },
  },
  home: {
    title: 'Inicio',
    products: 'Productos',
    categories: 'Categorías',
    search: 'Busca una dirección',
    searchButton: 'Comenzar',
    searchTitle: 'Cómo quieres hoy tu pedido',
    searchTitleONLY_ADD_FAVORITE: 'Busca la dirección',
    searchSubtitle:
      'Selecciona {pickup} si vas a pasar a recoger tu pedido o McDelivery si prefieres que te lo enviemos a una dirección',
    searchLocateMe: 'Usar mi ubicación actual',
    smartcards: {
      multiple: {
        title: 'Tienes varios pedidos en curso',
        secondary: 'Ver pedidos',
      },
      pending: {
        title: 'Pedido pendiente de pago',
        secondary: 'Ver detalle',
        primary: 'Pagar',
      },
      pendingPaymentCounter: {
        title: 'Pagar en mostrador',
        secondary: 'Ver detalle',
        primary: 'Llegué',
      },
      afterPayment: {
        pretitle: "Ir a McDonald's",
        title: 'Pedido en curso',
        secondary: 'Ver detalle',
        primary: 'Llegué',
      },
      advanceSale3days: {
        title: 'Pronto llegará el día de tu entrega',
        secondary: 'Saber más',
      },
      advanceSaleInDate: {
        title: 'Pedido listo para ser entregado',
        secondary: 'Saber más',
        primary: 'Recibir mi pedido',
      },
      accepted: {
        title: 'Tu pedido fue aceptado',
        secondary: 'Ver detalle',
      },
      acceptedPaymentCounter: {
        title: 'Pagar en mostrador',
        secondary: 'Ver detalle',
      },
      preparing: {
        title: 'Pedido en preparación',
        secondary: 'Ver detalle',
      },
      delivering: {
        title: 'Tu pedido está en camino',
        secondary: 'Ver detalle',
        primary: 'Seguir mi pedido',
      },
      ready: {
        title: 'Pedido listo para entregar',
        secondary: 'Ver detalle',
      },
      delivered: {
        title: 'Ya entregamos tu pedido',
        secondary: 'Ver detalle',
        primary: 'Repetir pedido',
      },
    },
    forYouProducts: {
      title: 'Para ti',
    },
  },
  sidebar: {
    title: {
      normal: 'Disfruta de la',
      bold: 'mejor experiencia',
    },
  },
  onboarding: {
    next: 'Continuar',
    stepRestaurant: {
      title: '¡Elige cómo lo prefieres!',
      description:
        '<ul><li><b>McDelivery</b> pide y recibe en cualquier lugar</li><li><b>{pickup}</b> busca un restaurante para retirar tu pedido</li></ul>',
    },
    stepRestaurantNoDlv: {
      title: '¡Elige cómo lo prefieres!',
      description: '<ul><li><b>{pickup}</b> busca un restaurante para retirar tu pedido</li></ul>',
    },
    stepMOP: {
      title: '{pickup}',
      description: 'Selecciona {pickup} si vas a pasar a recoger tu pedido',
    },
    stepDLV: {
      title: 'McDelivery',
      description: 'Selecciona McDelivery si prefieres que te lo enviemos a una dirección',
    },
    stepCart: {
      title: 'Mira tu pedido desde aquí',
      description: 'Encuentra todos los productos que elegiste y finaliza tu compra',
    },
    stepAccount: {
      title: 'Descubre “Mi cuenta”',
      description:
        'Completa tu perfil. Revisa tus preferencias ¡Y asegúrate de tener una experiencia única!',
    },
    stepQR: {
      title: 'Súmate a McID',
      description: "Escanea el código QR para identificarte rápidamente y unirte a McDonald's",
    },
  },
  dataOnboarding: {
    emailValidated: 'Correo validado con éxito',
    succeeded: 'Registro exitoso',
  },
  profile: {
    title: 'Mi Cuenta',
    account: 'Cuenta',
    downloadApp: 'Descargar App',
    help: 'Ayuda',
    sections: {
      personalData: 'Datos personales',
      fav: 'Favoritos',
      addressSaved: 'Direcciones guardadas',
      favRestaurants: 'Restaurantes favoritos',
      favProducts: 'Productos favoritos',
      historyOrders: 'Historial de pedidos',
      orderDetail: 'Tu pedido',
      paymentMethods: 'Métodos de pago',
      signInSecurity: 'Inicio de sesión y seguridad',
      manageDevices: 'Administrar dispositivos',
      billData: 'Datos de facturación',
      notification: 'Notificaciones',
      config: 'Configuración',
      logout: 'Cerrar sesión',
    },
    notLogged: {
      title: 'Te damos la bienvenida a <b>McDonald’s</b>',
      subtitle: 'Ingresa para disfrutar de nuestros productos, beneficios y más.',
    },
    subSections: {
      personalData: {
        fullName: 'Nombre y Apellido',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        password: 'Contraseña',
        birthday: 'Fecha de nacimiento',
        identityCard: 'Documento de identidad',
        dataNotProvide: 'Datos no proporcionados',
        formHeaders: {
          fullName: {
            title: 'Nombre y Apellido',
            subtitle: '¿Cómo quisieras que te llamemos?',
            button: 'Guardar',
          },
          phone: {
            title: 'Número de telefono',
            subtitle:
              'Con el fin de asegurar que solo tú tengas acceso a tu cuenta, por favor ingresa tu numero de teléfono',
            button: 'Guardar',
            buttonAlt: 'Validar y guardar',
            verified: 'Teléfono validado',
            notVerified: 'Teléfono no validado',
          },
          birthday: {
            title: 'Fecha de nacimiento',
            subtitle:
              'Introduce tu fecha de nacimiento. De esta manera, podremos garantizar la seguridad de tu información.',
            button: 'Continuar',
          },
          identityCard: {
            title: 'Documento de identidad',
            subtitle:
              'Introduce tu número de identidad. De esta manera, podremos garantizar la seguridad de tu información.',
            button: 'Continuar',
          },
        },
      },
      manageDevices: {
        text: 'Accediste a tu cuenta desde estos dispositivos. Si no reconoces alguno, puedes cerrar la sesión o cambiar los datos de acceso',
        thisDevice: 'En este dispositivo',
        noDevice: 'Dispositivo no identificado',
        logout: 'Cerrar sesión',
        logoutAll: 'Cerrar todas las sesiones',
        closeModals: {
          title: '¿Confirmas que quieres cerrar esta sesión?',
          body: '{name} - {appName}{location}, {timeAgo}',
          btnPrimary: 'Cerrar sesión',
          btnSecondary: 'Cancelar',
        },
        closeAllModals: {
          title: '¿Confirmas que quieres cerrar todas las sesiones abiertas?',
          body: 'Se cerrarán todas las sesiones menos la de este dispositivo',
          btnPrimary: 'Cerrar sesiones',
          btnSecondary: 'Cancelar',
        },
        toast: {
          success: 'Sesión cerrada con éxito',
          successAll: 'Sesiones cerradas con éxito',
          error: 'Ha habido un error. Por favor, inténtalo de nuevo',
        },
        errorModal: {
          title: 'Ocurrió un error al intentar eliminar este dispositivo',
          titleAll: 'Ocurrió un error al intentar eliminar todos los dispositivos',
          body: 'Verifica tu conexión e inténtalo de nuevo',
          bodyRetry: 'Puedes intentar de nuevo o cancelar',
          button: 'Intentar de nuevo',
        },
      },
      deleteAccount: {
        title: 'Eliminar cuenta',
        alert: {
          title: "Ingresa a la app de McDonald's para eliminar tu cuenta",
          body: 'La eliminación de la cuenta no está disponible desde la web.',
          btnPrimary: 'Volver al inicio',
        },
      },
      mySavedAddresses: {
        empty: 'Aquí puedes ver tus direcciones guardadas',
        addNew: {
          title: 'Guardar nueva dirección',
          subtitle: 'Encuentra una nueva dirección',
        },
        delete: {
          title: '¿Seguro que quieres eliminar esta dirección?',
          body: 'Al hacerlo, perderás la información guardada',
          btnPrimary: 'Eliminar',
          btnSecondary: 'Cancelar',
        },
        toast: {
          addNew: 'Dirección guardada con éxito',
          limitReached:
            'Alcanzaste el límite de direcciones guardadas. Elimina una para agregar otra',
        },
      },
    },
    VError: {
      required: 'Campo requerido',
      customPattern: 'El campo no tiene un formato correcto',
      strongPassword:
        'La contraseña debe contener un mínimo de 8 caracteres, 1 letra en mayúscula, 1 número y 1 carácter especial.',
      passwordMatch: 'La contraseñas deben coincidir.',
      email: 'Email no válido',
      nameValidation:
        'Nombre no válido. Los nombres válidos sólo contienen letras, guiones (-) y espacios.',
      ageValidation: 'Debes ser mayor de {minAge} años para poder usar la app',
      minLength: 'El campo no cumple con el mínimo de caracteres',
      maxLength: 'El campo no cumple con el máximo de caracteres',
      cpfValidation: 'El documento no tiene un formato correcto',
      cpfVerified: 'Número ya registrado',
      phoneValidation: 'El número no tiene un formato correcto',
      invalidAge: 'No cumples con la edad requerida',
      duplicatePhone: 'Teléfono ya registrado',
      validDate: 'Fecha inválida (dd/mm/yyyy)',
      notInFuture: 'La fecha no puede ser futura',
    },
    inputs: {
      dropdownPlaceholder: 'Elige uno',
      documentNumberPlaceholder: 'Nº de documento',
      phoneNumberPlaceholder: 'Nº de teléfono',
      labelName: 'Nombre',
      labelLastName: 'Apellido',
      labelPrefix: 'Prefijo',
      labelSufix: 'Número',
      labelCpfType: 'Tipo documento',
      labelCpf: 'Documento',
    },
    tooltipProfile: {
      greeting: 'Hola',
    },
  },
  productDetail: {
    customization: {
      title: 'Personaliza tu producto',
      customizingTitle: '¿Cómo quieres personalizar?',
      extra: 'Extra:',
      actions: {
        save: 'Guardar',
        customize: 'Personalizar',
        select: 'Seleccionar',
        change: 'Cambiar',
        add: 'Agregar',
      },
      chooseOne: 'Elige uno ',
      mandatory: '(Obligatorio)',
    },
    sizes: {
      title: 'Selecciona un tamaño',
      types: {
        SMALL: {
          letter: 'P',
          title: 'Pequeño',
        },
        MEDIUM: {
          letter: 'M',
          title: 'Mediano',
        },
        LARGE: {
          letter: 'G',
          title: 'Grande',
        },
      },
      upselling: 'Solo por',
    },
    actions: {
      payNow: 'Pagar ahora',
      addToCart: 'Añadir al carrito',
      save: 'Guardar',
      unavailable: 'Producto no disponible',
    },
    alerts: {
      outdaypart: 'Este producto no se encuentra disponible en este momento',
      mcDia: {
        expired: {
          title: 'Producto Gran Día fuera de fecha',
          content: 'Este producto ya no está disponible',
        },
      },
      notAvailableAreas: {
        title: 'Zona de entrega no disponible: {value}',
        titleMultiple: 'Zonas de entrega no disponibles: {value}',
      },
      mismatching: {
        NO_RESTAURANT_SELECTED: 'No tienes restaurante seleccionado',
        MISMATCHING_AREA: {
          MOP: 'Este producto sólo está disponible para recoger en local',
          DLV: 'Este producto sólo está disponible para envio a domicilio',
        },
        MISMATCHING_RESTAURANT: 'Este producto no está disponible en tu restaurante',
        MISMATCHING_AREA_RESTAURANT: 'Este producto no está disponible en tu restaurante',
      },
    },
    mismatching: {
      alerts: {
        NO_RESTAURANT_SELECTED: {
          title: 'No tienes restaurante seleccionado',
          body: 'Este producto está asociado al restaurante {restaurantName}',
          accept: 'Continuar',
          cancel: 'Seleccionar otro restaurante',
        },
        MISMATCHING_AREA: {
          titleMOP: 'Este producto sólo está disponible para recoger en local',
          titleDLV: 'Este producto sólo está disponible para envio a domicilio',
          body: '',
          accept: 'Seleccionar otro restaurante',
          cancel: '',
        },
        MISMATCHING_RESTAURANT: {
          title: 'Este producto no está disponible en tu restaurante',
          body: '',
          accept: 'Buscar en mi restaurante',
          cancel: 'Seleccionar otro restaurante',
        },
        MISMATCHING_AREA_RESTAURANT: {
          title: 'Este producto no está disponible en tu restaurante',
          body: '',
          accept: 'Continuar comprando',
          cancel: 'Seleccionar otro restaurante',
        },
        notFoundProductOnCatalog: {
          title: 'Este producto no se ha podido encontrar en tu restaurante',
          body: '',
          accept: 'Ver catálogo',
        },
      },
    },
    productLimit:
      'Límite de { count } producto por persona | Límite de { count } productos por persona',
  },
  productDetailStatic: {
    menu: "Menú Mcdonald's",
    moreInfo: 'Más información',
    nutritional: {
      title: 'Información nutricional',
      type: 'Información Nutricional',
      byProduct: 'Por Producto',
      idr: 'I.D.R',
      empty: 'Este producto no tiene información nutricional',
      items: {
        weight: 'Peso',
        calories: 'Calorías (Kcal)',
        sugarTotals: 'Azúcares totales',
        sugarAdded: 'Azúcares agregados',
        lipids: 'Grasas',
        saturatedFats: 'Grasas Saturadas',
        transFats: 'Grasas trans',
        fiber: 'Fibra',
        carbohydrates: 'Carbohidratos Totales',
        proteins: 'Proteínas',
        sodium: 'Sodio',
      },
    },
    allergens: {
      title: 'Información sobre alérgenos',
      tableTitle: 'Este producto contiene',
      empty: 'Este producto no contiene alérgenos',
      items: {
        twilight: 'Tinte amarillo crepúsculo',
        allura: 'Colorante rojo allura',
        fish: 'Pescado',
        milk: 'Leche',
        soy: 'Soja',
        almonds: 'Almendras',
        lactose: 'Lactosa',
        pepper: 'Pimienta',
        grain: 'Trigo',
        tartrazine: 'Colorante amarillo tartrazina',
        egg: 'Huevo',
        gluten: 'Gluten',
        walnuts: 'Nueces',
        sulphites: 'Sulfitos',
        cereals: 'Cereales',
        mustard: 'Mostaza',
        nuts: 'Frutos secos',
        sesame: 'Sésamo',
        crustaceans: 'Crustáceos',
        peanut: 'Maní',
        latex: 'Latex Natural',
        wheat: 'Trigo, avena, cebada y centeno',
        hazelnuts: 'Avellanas',
        cashewnuts: 'Anacardos',
        brazilnuts: 'Nueces de Brasil',
        macadamias: 'Nueces de macadamia',
        pecans: 'Nueces de pecan',
        pistachios: 'Pistachos',
        pinoli: 'Piñones',
        chestnuts: 'Castañas',
      },
    },
  },
  shoppingCart: {
    title: 'Mi pedido',
    products: 'Productos',
    discount: 'Descuento',
    total: 'Total',
    subtotal: 'Subtotal',
    shipping: 'Envío',
    tip: 'Propina',
    tax: 'Impuestos',
    points: 'Puntos consumidos',
    moneyRefund: 'Devolución',
    pointsRefund: 'Devolución de puntos',
    extras: 'Extras',
    summary: 'Resumen de tu pedido',
    empty: {
      title: 'Aún no has añadido ningún producto',
      text: 'Elige lo que te apetezca de nuestro menú o de entre nuestras ofertas, y disfrútalo en casa o en el restaurante McDonald’s que prefieras',
    },
    suggestive: {
      title: '¿Quieres agregar algo más?',
    },
    actions: {
      back: 'Continuar comprando',
      next: 'Siguiente',
      clear: 'Limpiar',
      edit: 'Editar',
      seeCart: 'Ver carrito',
      multipleFees: 'Saber más sobre impuestos',
    },
    promotions: {
      addPromo: {
        title: 'Códigos de descuento y promociones',
        add: 'Aplicar',
        prefix: {
          coupon: 'Código',
          employee: 'Descuento de empleado',
          applied: 'Hemos aplicado',
        },
        terms: {
          prefix: 'Para más información consulta los',
          link: 'términos y condiciones',
          sufix: 'del código de descuento.',
        },
      },
      modal: {
        title: 'Descuentos y promociones',
        disclaimer: 'Recuerda que los descuentos y promociones no son acumulables entre si.',
        fields: {
          coupon: {
            label: 'Ingresa tu código promocional',
          },
          employee: 'Descuento de empleado',
        },
        subtitles: {
          coupon: 'Descuento por código',
          employee: 'Descuento de empleado',
        },
        actions: {
          viewTerms: 'Ver términos y condiciones',
          removeCoupon: 'Eliminar código',
          accept: 'OK',
        },
        codeError: 'Lo sentimos. El código de descuento no es válido',
      },
      deepLinks: {
        seeCartProducts: 'Para ver tu descuento entra en el carrito',
        addCartProducts: 'Para disfrutar del descuento, agrega productos al carrito',
      },
    },
    alerts: {
      delete: {
        title: '¿Quieres eliminar este producto?',
        body: 'Al eliminarlo se perderá también la personalización que hayas realizado.',
        cancel: 'Cancelar',
        accept: 'Eliminar',
      },
      login: {
        title: 'Es necesario estar registrado para poder continuar',
        body: 'Pulsa en ingresar para disfrutar de la experiencia completa y muchos otros beneficios',
        cancel: 'Ahora no',
        accept: 'Ingresar',
      },
      clear: {
        title: 'Vas a eliminar todos los productos del carrito',
        body: '¿Estás seguro?, se vaciarán todos los items que tienes actualmente en tu carrito',
        cancel: 'Cancelar',
        accept: 'Vaciar',
      },
      cancelOrderConfirmation: {
        title: '¿Estás seguro que deseas cancelar tu pedido?',
        accept: 'Cancelar pedido',
        body: '¡No hay problema! Tu dinero sera reintegrado en 1 o 2 dias hábiles segun la entidad bancaria.',
        cancel: 'Volver',
      },
      deletePromotedConfirmation: {
        title: '¿Quieres eliminarlo?',
        body: 'Al hacerlo se eliminarán todos los productos que correspondan a la promoción.',
        accept: 'Eliminar',
        cancel: 'Cancelar',
      },
    },
    toast: {
      orderMcdia: 'Esta promoción no es compatible con los productos de tu pedido',
      promotionApplied: 'Promoción aplicada correctamente',
      promotionDeleted: 'Promoción eliminada correctamente',
      promotionAppliedDiscount: 'Has ganado {value} de descuento',
      product: {
        add: 'Producto añadido correctamente al carrito',
      },
    },
    feesInfo: {
      title: 'Información sobre los impuestos',
      serviceFee: {
        name: 'Tarifa de servicio',
        info: 'Tarifa que cubre costos de operación de la plataforma y el seguimiento de pedidos',
      },
      taxes: {
        name: 'Impuestos',
        info: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex voluptas ab voluptatem recusandae et esse ducimus alias, deserunt laborum sed similique, nam odit necessitatibus facilis minus rem qui tempore sit.',
      },
      smallOrderFee: {
        name: 'Tarifa de pedido pequeño',
        info: 'Tarifa en pedidos con un subtotal inferior a un importe determinado. Puedes eliminarla añadiendo más artículos al carrito.',
      },
    },
  },
  checkout: {
    title: 'Detalle del pago',
    checkoutAlert: 'Mensaje',
    actions: {
      pay: 'Pagar',
      order: 'Pedir',
    },
    sections: {
      address: {
        title: 'Dirección de entrega',
      },
      tip: {
        title: 'Propina para tu repartidor',
        description:
          'Esta propina es voluntaria y la recibe tu repartidor como reconocimiento por su trabajo',
        chips: {
          custom_amount: 'Otra',
          custom_percent: 'Otro',
        },
        toast: {
          max: 'El porcentaje máximo de la propina es {max} %',
        },
      },
      paymentMethods: {
        title: 'Método de pago',
        add: 'Agregar nueva tarjeta',
        modify: 'Modificar tarjetas',
        methodTypes: {
          cash: 'Pago en efectivo',
          credit: 'Crédito',
          debit: 'Débito',
          inPerson: 'En mostrador',
          mercado_pago_checkout_pro: 'MercadoPago',
          account_money: 'MercadoPago',
          yappy: 'Yappy',
          yape: 'Yape',
          pix: 'Pix',
          google_pay: 'Google Pay',
          sodexo: 'Pluxee',
          alelo: 'Alelo',
          elo: 'Elo',
          nu_pay: 'NuPay',
          pse: 'PSE',
          apple_pay: 'Apple Pay',
          modo: 'Modo',
        },
        extraMethods: {
          mercado_pago_checkout_pro: 'Mercado Pago',
        },
        expired: 'Expirada',
        toast: {
          cardSave: {
            success: 'Tarjeta guardada correctamente',
            error: 'No fue posible guardar la tarjeta',
          },
          yappy:
            'Recuerda que al hacer tu pedido por Yappy, este no se podrá cancelar desde nuestra app',
        },
        modifyCards: {
          disclaimer: 'Recuerda que puedes guardar hasta un máximo de {value} tarjetas.',
          actions: {
            add: 'Añadir tarjeta',
          },
          expiration: 'Expiración',
          alerts: {
            deleteCard: {
              title: '¿Quieres eliminar esta tarjeta?',
              accept: 'Eliminar',
              cancel: 'Cancelar',
            },
          },
        },
        transition: {
          title: 'Recibimos tu pedido :)',
          subtitle: 'Aguardamos la confirmación de pago.',
        },
        exclusivePayment:
          'Ten en cuenta que sólo tienes disponible para esta promoción el método de pago seleccionado a continuación',
      },
      fiscal: {
        title: 'Datos de facturación',
        filled: {
          delete: 'No quiero factura',
          action: 'Cambiar',
        },
        unfilled: {
          subtitle: '¿Quieres solicitar factura?',
          subtitleMandatory:
            'Para compras igual o superiores a {price} debes introducir tus datos en la factura.',
          subtitleMandatoryAlways: 'La factura es obligatoria',
          action: 'Solicitar',
        },
        modal: {
          action: 'Confirmar',
          checkbox: 'Recordar para futuras compras',
        },
        alert: {
          mandatory: {
            title: 'Ingresa tus datos de facturación para completar la compra',
            bodyMandatoryAlways: 'Datos obligatorios',
            bodyMandatory: 'Datos obligatorios para compras mayores o iguales a {price}',
            accept: 'Aceptar',
            cancel: '',
          },
        },
      },
    },
    paymentResult: {
      yuno: {
        SUCCESS: {
          MOP: {
            title: 'Pago realizado con éxito',
            description:
              'Cuando te encuentres en el restaurante elige una opción para retirar tu pedido',
            actions: {
              accept: 'Opciones de retiro',
              acceptMcdia: 'Ver mis pedidos',
              alternative: 'Elegir después',
            },
          },
          DLV: {
            title: 'Pago realizado con éxito',
            description: 'El pedido está siendo preparado. En breve lo recibirás en tu dirección.',
            actions: {
              accept: 'Seguir mi pedido',
              acceptMcdia: 'Volver a la home',
              alternative: 'Ver detalles',
            },
          },
        },
        ERROR: {
          paymentDidNotHappen: {
            title: 'Pago no realizado',
            description:
              'Hubo un problema al procesar tu pago. Puedes intentar de nuevo o elegir otra tarjeta. Si el problema continúa contacta a tu banco.',
            actions: {
              accept: 'Intentar de nuevo',
              alternative: 'Cambiar tarjeta',
            },
          },
          genericError: {
            title: 'Algo salió mal 🙁',
            description:
              'Verifica si los datos fueron ingresados correctamente. Puedes intentar de nuevo o elegir otra tarjeta. Si el problema continúa contacta a tu banco.',
            actions: {
              accept: 'Cambiar tarjeta',
              alternative: 'Intentar de nuevo',
            },
          },
        },
      },
      legacy: {
        success: {
          title: 'Tu pago fue realizado con éxito',
          description:
            'Sigue las instrucciones en la próxima pantalla y podrás retirar tu pedido como quieras.',
          actions: {
            accept: 'Entendido',
            acceptMcdia: 'Ver mis pedidos',
          },
        },
        restaurantOrderError: {
          title: '¡Lo sentimos! Tu orden no pudo ser creada',
          description: 'Ha ocurrido un error creando la orden en el restaurante',
          actions: {
            accept: 'Ver pedido',
          },
        },
        paymentError: {
          title: '¡Lo sentimos! Tu pago no pudo ser realizado',
          description:
            'Hubo un problema al procesar la operación. Reintenta o elige otro medio de pago.',
          actions: {
            accept: 'Ver pedido',
            alternative: 'Elegir otro medio de pago',
          },
        },
      },
      freeOrder: {
        success: {
          title: '¡Pedido exitoso!',
          actions: {
            accept: 'Volver a la home',
          },
        },
      },
    },
  },
  pickupMethods: {
    farAway: {
      title: 'Estás lejos del restaurante',
      subtitle:
        'En algunos minutos tu pedido estará listo. ¿Está seguro de que desea elegir una opción de entrega y empezar la preparación?',
      actions: {
        continue: 'Opciones de entrega',
        imOnWay: 'Estoy en camino',
      },
    },
    areaSelection: {
      backTitle: 'Métodos de retiro',
      info: 'La preparación del pedido comienza aquí. En algunos minutos tu pedido quedará listo',
      areas: {
        title: '¿Cómo deseas retirar tu pedido?',
        MOP: {
          title: 'En mostrador',
          description: 'Dirígete a la zona de entrega',
          step: {
            title: '¿Cómo prefieres tu pedido?',
            subtitle: 'Elige la opción que desees para que podamos prepararlo',
            type: {
              EATIN: 'Comer en el restaurante',
              TAKEOUT: 'Envolver para llevar',
            },
          },
          area: {
            value: 'Número',
            title: 'Anúnciate en la zona de entrega con tú número',
            titleDualPoint: 'Retira tu pedido cuando veas tu número en pantalla',
            titleInPerson: 'Dirígete al mostrador para pagar tu pedido',
            subtitle: 'Estamos preparando tu pedido',
            subtitleInPerson: 'La preparación del pedido comenzará una vez realizado el pago.',
            alerts: {
              noOrderNumber: {
                title: 'No se ha podido obtener el número de retiro',
                accept: 'Ir al detalle del pedido',
                body: '',
                cancel: 'Cancelar',
              },
            },
          },
          counterSelection: {
            counters: {
              title: '¿En qué mostrador quieres retirar tu pedido?',
              subtitle: 'Elige el mostrador que prefieras para retirar tu pedido en el restaurante',
              counterNum: 'Mostrador nº {number}',
            },
          },
        },
        AUT: {
          title: 'Por AutoMac',
          description: 'Ingresa hasta el parlante y anúnciate',
          step: {
            title: 'Tu pedido será entregado por AutoMac',
            subtitle:
              'Se iniciará la preparación al confirmar el método de retiro y el pedido no podrá ser cancelado',
            action: 'Confirmar',
          },
          area: {
            value: 'Número',
            title: 'Ingresa y avanza hasta el parlante para anunciarte y retira tu pedido',
            subtitle: '',
          },
        },
        EALM: {
          title: 'En la mesa',
          description: 'Llevamos el pedido a tu mesa',
          step: {
            title: 'Escribe el número de tu mesa',
            subtitle:
              'Se iniciará la preparación al confirmar el método de retiro y el pedido no podrá ser cancelado',
            help: 'Lo verás pegado en uno de los extremos',
            action: 'Confirmar',
          },
          area: {
            value: 'Mesa',
            title: '¡Ahora sólo queda esperar!',
            subtitle: 'Pronto recibirás tu pedido listo para disfrutar',
          },
        },
        CURB: {
          title: 'En el estacionamiento',
          description: 'Llevamos el pedido a tu cochera',
          step: {
            title: 'Escribe el número de tu cochera',
            subtitle:
              'Se iniciará la preparación al confirmar el método de retiro y el pedido no podrá ser cancelado',
            help: 'Busca las cocheras señalizadas para que podamos llevar tu pedido',
            helpLink: '¿Las cocheras estan ocupadas?',
            action: 'Confirmar',
          },
          area: {
            value: 'Cochera',
            title: '¡Ahora sólo queda esperar!',
            subtitle: 'Pronto recibirás tu pedido listo para disfrutar',
          },
        },
        disabled: {
          title: 'El servicio {areaTranslated} no está disponible para este pedido.',
          subtitle: 'Elija otra opción de entrega',
        },
      },
      formErrors: {
        required: 'El valor es requerido',
        minValue: 'El valor mínimo es {minimum}',
        maxValue: 'El valor máximo es {maximum}',
      },
    },
  },
  errors: {
    page: {
      title: 'Ooops...',
      subtitle: 'Algo ha salido mal',
      description: 'Parece que la página que buscas no existe',
    },
    toast: {
      geo: {
        denied:
          'El permiso de geolocalización ha sido denegado. Por favor, habilítelo si desea utilizar el botón para localizarle.',
        unsupported: 'La geolocalización no es soportada por este navegador',
        geocoderError: 'Ha ocurrido un error al obtener la dirección',
        unexpectedError: 'Ha ocurrido un error inesperado. Inténtalo de nuevo en unos instantes',
      },
      generic: 'Hubo un problema. Por favor, inténtalo de nuevo más tarde',
    },
    alerts: {
      generic: {
        title: 'Ha ocurrido un error inesperado',
        accept: 'Aceptar',
        body: 'Inténtalo de nuevo pasados unos minutos.',
        cancel: '',
      },
      tokenExpired: {
        title: 'Información',
        body: 'Tu tiempo para realizar el pedido ha finalizado, debes volver a identificarte para terminarlo.',
        accept: 'Aceptar',
        cancel: '',
      },
      noCoverage: {
        title: 'McDelivery no está disponible ahora',
        body: 'Mientras tanto, puedes hacer un pedido y retirarlo en el restaurante más cercano con Pide y Retira',
        accept: 'Pide y Retira',
        cancel: 'Intentar más tarde',
      },
      noRestaurantsOpened: {
        title: 'Lo sentimos, el restaurante se encuentra cerrado',
        body: 'Puedes elegir otra dirección o mira si hay un restaurante cerca para recoger tu pedido',
        accept: 'Buscar restaurantes cercanos',
        cancel: 'Cancelar',
      },
      noRiders: {
        title: 'Nuestros repartidores están ocupados',
        body: 'Puedes intentar más tarde o hacer un pedido y retirarlo con Pide y Retira',
        accept: 'Pide y Retira',
        cancel: 'Intentar más tarde',
      },
      productNotAvailable: {
        title: '¡La promoción ya finalizó!',
        body: 'Cambia los productos de tu pedido para continuar con la compra',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      orderErrorPrice: {
        title: 'No se ha podido tramitar su pedido',
        accept: 'Aceptar',
        body: 'Inténtalo de nuevo pasados unos minutos.',
        cancel: 'Cancelar',
      },
      platformNotValidForPromo: {
        title: 'Esta promoción no es compatible',
        body: 'Por favor, selecciona otro método de pago para completar la compra',
        accept: 'Elegir otro método de pago',
        cancel: '',
      },
      orderInProgressMultiple: {
        title: 'Has alcanzado el máximo de pedidos en curso',
        accept: 'Mis pedidos',
        body: 'Hasta que no retires al menos uno de tus pedidos en curso, no podrás iniciar otra compra.',
        cancel: 'Cancelar',
      },
      orderPickupNotAvailable: {
        title:
          'El restaurante seleccionado en un pedido anterior no se encuentra disponible en este momento',
        accept: 'Aceptar',
        body: 'Por favor, seleccione un nuevo restaurante.',
        cancel: 'Cancelar',
      },
      orderGeneric: {
        title: '¡Ups! Sucedió algo inesperado',
        body: 'Tuvimos un problema para completar tu pedido. Por favor, inténtalo de nuevo',
        accept: 'Reintentar',
        cancel: '',
      },
      orderInProcess: {
        title: 'Error',
        body: 'El pedido ya está en camino',
        accept: 'Aceptar',
        cancel: 'Cancelar',
      },
      promotionNotFound: {
        title: '¡La promoción ya finalizó!',
        body: 'Cambia los productos de tu pedido para continuar con la compra',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      orderProductMismatch: {
        title: 'Error al crear su pedido',
        body: 'Ha habido un error con la creación de su pedido y no puede ser realizado.',
        accept: 'Aceptar',
        cancel: '',
      },
      countryNotValid: {
        title: '¡Ups! Sucedió algo inesperado',
        body: 'Tuvimos un problema para completar tu pedido. Por favor, inténtalo de nuevo',
        accept: 'Reintentar',
        cancel: '',
      },
      paymentPendingApproval: {
        title: 'Ya ha intentado un pago para este pedido',
        body: 'El pago de su pedido está pendiente de aprobación. Consulte el estado de su pedido en unos minutos',
        accept: 'Aceptar',
        cancel: '',
      },
      orderAlreadyPaid: {
        title: 'El pedido ya ha sido pagado',
        accept: 'Aceptar',
        body: '',
        cancel: 'Cancelar',
      },
      promotionNotAvailable: {
        title: 'La promoción ya no está disponible y no podrá ser aplicada en este pedido.',
        body: '',
        accept: 'Aceptar',
        cancel: '',
      },
      orderMcdia: {
        title: '¡Tu compra no puede ser realizada!',
        body: 'Los productos McDia Feliz no se pueden comprar con otros productos. Para continuar con la compra debes eliminar los productos que no correspondan con la campaña.',
        accept: 'Eliminar productos',
        cancel: '',
      },
      fiscalFieldsRequired: {
        title: '¡Ups! No pudimos completar tu pedido',
        body: 'Por favor, comprueba los datos de tu factura y vuelve a intentarlo',
        accept: 'Reintentar',
        cancel: '',
      },
      antifraudTemporalBlock: {
        title: 'Superaste el límite de intentos de pago',
        body: 'No pudimos completar el pedido. Por favor, revisa los datos de tu tarjeta y vuelve a intentarlo en otro momento',
        accept: 'Volver a la home',
        cancel: '',
      },
      antifraudLimitTransactionsReached: {
        title: '¡Gracias por hacernos parte de tu día!',
        body: 'Alcanzaste el límite de compras diarias. Te esperamos pronto para seguir disfrutando',
        accept: 'Volver a la home',
        cancel: '',
      },
      phoneValidationRequired: {
        title: 'Valida tu teléfono',
        body: 'Necesitas validar tu teléfono para realizar un pedido',
        accept: 'Aceptar',
        cancel: '',
      },
      deviceValidationRequired: {
        title: 'Valida tu dispositivo',
        body: 'Necesitas validar tu dispositivo para realizar un pedido',
        accept: 'Aceptar',
        cancel: '',
      },
      outOfDayPart: {
        title: 'Producto fuera de horario. No olvides cancelar el pedido',
        body: 'Tu compra no puede ser entregada, porque uno de los productos no se encuentra dentro de su horario de entrega. Una vez cancelado, tu dinero será reintegrado en 1 o 2 días hábiles',
        accept: 'Cancelar pedido',
        cancel: '',
      },
      orderMcdiaOutOfDates: {
        title: "McDonald's",
        body: 'Plazo expirado, el pedido no puede ser retirado',
        accept: 'OK',
        cancel: '',
      },
      orderNotExist: {
        title: 'El pedido no existe',
        body: 'No se encuentra el pedido solicitado',
        accept: 'Ir a productos',
        cancel: 'Cancelar',
      },
      pickup_unhandled: {
        title: 'No se ha podido establecer el método de retiro de tu pedido',
        body: '',
        accept: 'Inténtalo de nuevo',
        cancel: 'Cancelar',
      },
      pickup_noRestaurantsOpened: {
        title: 'Restaurante cerrado',
        body: 'Lo sentimos, el restaurante está cerrado o próximo a cerrar y ya no admite pedidos. Podrás recoger tu pedido cuando esté abierto de nuevo',
        accept: 'Continuar',
        cancel: 'Cancelar',
      },
      pickup_serviceNumberEmpty: {
        title: '¡Ups! Sucedió algo inesperado',
        body: 'Tuvimos un problema al cargar el número que ingresaste. Por favor, inténtalo de nuevo',
        accept: 'Reintentar',
        cancel: '',
      },
      pickup_anyPickupAreaForThisOrderIsAvailable: {
        title: 'El restaurante ya no está disponible',
        body: 'Puedes cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
        accept: 'Ir a mi pedido',
        cancel: '',
      },
      anyPickupAreaForThisOrderIsAvailable: {
        title: 'El restaurante ya no está disponible',
        body: 'Puedes cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
        accept: 'Ir a mi pedido',
        cancel: '',
      },
      pickup_orderPickupNotAvailable: {
        title: 'El restaurante ya no está disponible',
        body: 'Puedes cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
        accept: 'Ir a mi pedido',
        cancel: '',
      },
      pickup_areaNotAvailable: {
        title: 'El restaurante ya no está disponible',
        body: 'Puedes cancelar el pedido para obtener un reembolso y elegir otra opción ¡Te pedimos disculpas!',
        accept: 'Ir a mi pedido',
        cancel: '',
      },
      promoExclusivePaymentUsed: {
        title: '¡Ups! Ya has aprovechado esta promoción',
        body: 'Vuelve al carrito y cambia los productos para poder continuar con el pedido',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      limitProductExclusivePayment: {
        title: 'Solo permitimos un artículo promocional por compra',
        body: 'Puedes conservar otros productos del menú en esta compra, pero sólo puedes agregar la oferta promocional una vez',
        accept: 'Comprendí',
        cancel: '',
      },
      limitedPromoProduct: {
        title: 'Tu pedido ya incluye productos con descuento',
        body: '¿Quieres mantener los descuentos actuales o aplicar el nuevo código?',
        accept: 'Mantener descuentos',
        cancel: 'Aplicar nuevo código',
      },
      employeeDiscount: {
        title: 'Tu pedido ya tiene descuentos aplicados',
        body: '¿Quieres reemplazar la promoción o agregar el producto sin descuento?',
        accept: 'Agregar sin descuento',
        cancel: 'Reemplazar promoción',
      },
      areaNotFound: {
        title: 'El restaurante no está disponible para los productos seleccionados',
        body: 'Puedes elegir otro restaurante o volver a tu pedido y cambiar los productos',
        accept: 'Volver a mi pedido',
        cancel: 'Cambiar restaurante',
      },
      limitPriceOrder: {
        title: 'Alcanzaste el límite de compra por pedido',
        body: 'Superaste el valor máximo de {value}. Por favor, revisa los productos del carrito',
        bodyDLV:
          'Superaste el valor máximo de {value}. Para continuar, te sugerimos dividir los productos en dos o más pedidos',
        accept: 'Volver a mi pedido',
        cancel: '',
      },
      restaurantNotLoyalty: {
        title: 'Este restaurante no participa de {value}',
        body: 'Para continuar, cambia los productos de tu pedido o elige otro restaurante. Si lo haces, se vaciará tu carrito',
        accept: 'Volver a mi pedido',
        cancel: 'Cambiar restaurante',
      },
      cumulativePromotionsNotAllowed: {
        title: 'Tu pedido ya tiene descuentos aplicados',
        body: '¿Quieres reemplazar la promoción o agregar el producto sin descuento?',
        accept: 'Agregar sin descuento',
        cancel: 'Reemplazar promoción',
      },
      autoApplicablePromotionNotAllowed: {
        title: 'Tu pedido ya incluye productos con descuento',
        body: '¿Quieres mantener los descuentos actuales o aplicar el nuevo código?',
        accept: 'Mantener descuentos',
        cancel: 'Aplicar nuevo código',
      },
      pickup_counterNotAvailable: {
        title: 'No fue posible seleccionar el mostrador',
        body: 'El mostrador seleccionado no está disponible en este momento. Elige otra opción para retirar tu pedido',
        accept: 'Elegir otra opción',
        cancel: '',
      },
      cartEmpty: {
        title: 'Tu carrito está vacío',
        body: 'Elige tus productos favoritos y empieza a disfrutar',
        accept: 'Volver a la home',
        cancel: '',
      },
      addressRequired: {
        title: '¡Ups! Sucedió algo inesperado',
        body: 'Tuvimos un problema para completar tu pedido. Por favor, vuelve a intentarlo',
        accept: 'Reintentar',
        cancel: '',
      },
      userLimitReachedProduct: {
        body: 'Alcanzaste el límite de compras de este producto',
      },
      globalLimitReachedProduct: {
        body: 'Este producto está agotado',
      },
      limitProductGeneric: {
        body: 'Este producto no está disponible',
      },
      productLimitExceeded: {
        title: '¡Ups! Llegaste al límite de compra',
        body: 'Alcanzaste el límite permitido para alguno de los productos de tu pedido',
        accept: 'Ok',
        cancel: '',
      },
      globalLimitExceeded: {
        title: '¡Ups, se acabó!',
        body: 'Alguno de los productos de tu pedido está agotado en este momento',
        accept: 'Ok',
        cancel: '',
      },
    },
  },

  selectRestaurant: {
    DLV: {
      titleAddingOrEditingFavorite: 'Direcciones guardadas',
      noNumber: 'Sin número',
      addAddressError: 'Es necesario completar este campo',
      additionlInfoError: 'Es necesario completar este campo',
      confirmAddress: 'Confirma tu dirección',
      street: 'Calle',
      number: 'Número',
      additionalInfo: 'Indicaciones adicionales para el repartidor',
      additionalInfoPlaceholder: 'Casa, piso, dpto...',
      additionalInfoDeliveryPlaceholder: 'Ayúdanos a entregar tu pedido',
      willSendTo: 'Enviaremos tu pedido a',
      confirmLocation: 'Confirmar',
      favorite: {
        saveTitle: 'Guardar como dirección favorita',
        formTitle: '¿Cómo quieres guardar esta dirección?',
        keys: {
          home: 'Casa',
          work: 'Trabajo',
          other: 'Otro nombre',
        },
        fields: {
          alias: {
            label: 'Elige un nombre para esta dirección',
            required: 'El nombre para la dirección es obligatorio',
          },
        },
      },
    },
    MOP: {
      findYourMcDonalds: 'Encuentra tu McDonald’s',
      seeList: 'Ver listado',
      seeMap: 'Ver mapa',
      emptyList: 'No hemos encontrado restaurantes cercanos en esa ubicación.',
    },
    map: {
      adjustPin: 'Ajusta el pin en la posición adecuada',
    },
    lupap: {
      city: 'Ciudad',
      form: {
        address: 'Dirección',
        complement: 'Edificio, torre, apartamento ...',
      },
      continue: 'Continuar',
    },
    filters: {
      driveThru: 'AutoMac',
      mcCafe: 'McCafé',
      openNow: 'Abierto ahora',
    },
  },
  alertDialog: {
    mcDeliveryError: {
      title: '¡McDelivery llegará pronto a tu zona!',
      body: 'Mientras tanto, puedes hacer un pedido y retirarlo en el restaurante más cercano con @:common.MOP',
      btnPrimary: 'Buscar restaurantes cercanos',
      btnSecondary: 'Buscar otra dirección',
    },
    ridersError: {
      title: 'Lo sentimos, en estos momentos no hay repartidores disponibles en tu zona',
      body: 'Puedes elegir otra dirección o mira si hay un restaurante cerca para recoger tu pedido',
      btnPrimary: 'Buscar restaurantes cercanos',
      btnSecondary: 'Buscar otra dirección',
    },
    restaurantClosedError: {
      title: 'Lo sentimos, el restaurante se encuentra cerrado',
      body: 'Puedes elegir otra dirección o mira si hay un restaurante cerca para recoger tu pedido',
      btnPrimary: 'Buscar restaurantes cercanos',
      btnSecondary: 'Buscar otra dirección',
    },
    genericError: {
      title: 'Lo sentimos, ha ocurrido un error',
      body: 'Hubo un problema. Por favor, inténtalo de nuevo más tarde',
      btnPrimary: '',
      btnSecondary: '',
    },
    changeRestaurant: {
      titleMOP: '¿Estás seguro que deseas cambiar el restaurante de recogida?',
      titleDLV: '¿Estás seguro que deseas cambiar el restaurante de entrega?',
      body: 'Tendrás que comenzar tu pedido de nuevo y volver a seleccionar desde el menú.',
      btnPrimary: 'Cambiar restaurante',
      btnSecondary: 'Cancelar',
    },
  },
  restaurantTooltipAlert: {
    closed:
      'Recuerda que el restaurante seleccionado está cerrado y no acepta pedidos en este momento',
    riders: 'Parece que no hay riders en estos momentos',
    farFromRestaurant:
      'Parece que estas lejos del restaurante. Siempre puede cambiarlo pinchando sobre el.',
    farFromRestaurantOptions: {
      withoutGeo: {
        title: 'Verifica si esta dirección es correcta',
        subtitle:
          'Si la cambias, activa tu ubicación para que sea más precisa.<br/><b>¿Quieres elegir otra dirección?</b>',
      },
      withGeo: {
        title: '¡Notamos que estás lejos de este restaurante!',
        subtitle: '¿Quieres elegir otro?',
      },
    },
    actions: {
      dontChange: 'No, continuar',
      change: 'Sí, cambiar',
    },
    farFromRestaurantWithOrder: 'Notamos que estás lejos del restaurante donde hiciste el pedido',
    farFromRestaurantWithoutOrder:
      'Notamos que estás lejos del restaurante donde hiciste el pedido. Puedes cambiarlo presionando sobre la dirección',
  },
  restaurant: {
    status: {
      closed: 'Cerrado',
      nearToClose: 'Próximo a cerrar',
      onlyLocal: 'Sólo pedidos en local',
    },
    detail: {
      schedule: 'Horario',
      header: {
        MOP: 'Retirar en',
        DLV: 'Enviar a',
      },
      howToArrive: 'Cómo llegar',
      mop: 'Métodos de retiro',
      closed: 'Cerrado',
      services: {
        title: 'Servicios',
        breakfast: 'Desayuno',
        mcCafe: 'McCafé',
        driveThru: 'AutoMac',
        dcOut: '',
        dcIn: '',
        mcDelivery: '',
        timeExtended: '24 hs',
        mcParty: 'McParty',
        playPlace: 'PlaySpace',
        parking: 'Parking',
        wifi: 'WIFI',
        loyalty: '',
        wheelchairAccess: 'Acccesibilidad',
        dessertCenter: 'Dessert Center',
        shoppingCenter: 'Shopping Center',
      },
    },
  },
  help: {
    links: {
      faqs: {
        title: '¿Alguna duda?',
        linkText: 'Ayuda y FAQ’s',
      },
      whatsapp: {
        title: '¿Necesitas ayuda?',
        titleAlt: 'También estamos en',
        linkText: 'Whatsapp',
      },
      sac: {
        title: 'Atención al cliente',
        linkText: 'Teléfono',
      },
    },
  },
  orders: {
    orderNumber: 'Pedido nº',
    delivery: {
      deliveryCode: 'Código de entrega',
      sentFrom: 'Enviado desde',
      description: 'Informa el código al repartidor únicamente al recibir tu pedido',
    },
    date: {
      today: 'Hoy',
      yesterday: 'Ayer',
    },
    vouchers: {
      title: 'Código de reembolso',
      subtitle: 'Úsalo en tu próxima compra dentro de la App',
      subtitleOneUsed: 'Este código ya fue utilizado',
      subtitleAllUsed: 'Todos los códigos ya fueron utilizados',
    },
    historyOrders: {
      onGoing: 'No tienes ningún pedido en curso',
      finished: 'No tienes ningún pedido finalizado',
    },
    mcdiaCard: {
      defaultCampaignName: 'Evento',
      title: {
        beforeDate: 'Ya llega el {event}',
        onDate: 'Ya llegó el {event}',
      },
    },
    status: {
      pending: 'Pendiente de pago',
      pendingCounter: 'Pagar en mostrador',
      paymentDone: 'Pago Completado',
      paymentDoneMcdia: 'Preparándonos para el día',
      paymentDoneMcdia3days: 'Preparándonos para el día',
      paymentDoneMcdiaInDate: 'Listo para ser entregado',
      paymentDoneMcdiaExpired: 'Plazo expirado',
      goRestaurant: 'Ir al restaurante',
      received: 'Pedido Recibido',
      accepted: 'Aceptado',
      inProgress: 'En preparación',
      ready: 'Preparado',
      delivering: 'Entregando',
      cancelled: 'Cancelado',
      error: 'Error en el pedido',
      delivered: 'Entregado',
      finished: 'Finalizado',
      pickupExpired: 'Tiempo de retiro expirado',
      refunded: 'Reembolsado',
    },
    views: {
      cancelled: 'Pedido cancelado',
      success: 'Pedido entregado',
      refund: 'Pedido reembolsado',
      refundPartial: 'Reembolso aprobado',
      expired: 'Plazo expirado',
      finishedSections: {
        details: 'Detalles del envío',
        products: 'Tu pedido',
        payment: 'Resumen del pago',
        totalRefund: 'Tu reembolso fue aprobado',
        partialRefund: 'Tu reembolso parcial fue aprobado',
      },
    },
    ongoingSteps: {
      pending: {
        title: 'Pedido pendiente de pago',
        subtitle: 'Completa el pago para iniciar la preparación',
      },
      ready_for_prep: {
        title: 'Listos para preparar tu pedido',
        subtitle: 'Indica cómo lo quieres recibir',
      },
      accepted: {
        title: 'Ya recibimos tu pedido',
        subtitle: 'Confirmado a las {time}',
      },
      payment_pending_counter: {
        title: 'Paga en el mostrador',
        subtitle: 'Anúnciate con el número que te indicamos',
      },
      waiting_for_date: {
        title: 'Preparándonos para el día',
        subtitle: 'Confirmado a las {time}',
      },
      event_3_days: {
        title: 'Cada vez falta menos',
        subtitle: 'Lo mejor está por llegar…',
      },
      event_date: {
        DLV: {
          title: 'Listos para enviar tu pedido',
          subtitle: 'El {mcdiaDateFrom} confirma que quieres recibirlo',
        },
        MOP: {
          title: 'Listos para preparar tu pedido',
          subtitle: 'El {mcdiaDateFrom} esperamos tu confirmación para empezar',
        },
      },
      inform_aut_speaker: {
        title: 'Anúnciate en el parlante',
        subtitle: 'Informa el número que te indicamos',
      },
      preparing: {
        title: 'Preparando tu pedido',
        subtitle: '¡Estás a un momento de disfrutarlo!',
      },
      delivering: {
        title: 'Tu pedido está en camino',
        subtitle: '¡Prepárate para recibirlo!',
      },
      delivered: {
        title: 'Pedido entregado',
        subtitle: 'Cuéntanos cómo fue la experiencia',
      },
    },
    inpersonWhatYouPaying: {
      title: 'Lo que vas a pagar',
      subtitleMOP: 'La preparación del pedido comenzará una vez realizado el pago',
    },
    areas: {
      aut: 'Entrega en AutoMac',
      ealm: 'Entrega a la mesa',
      mop: 'Entrega en mostrador',
      mopCounter: 'Entrega en Mostrador nº {number}',
      curb: 'Entrega en estacionamiento',
      subtitle: {
        mopDualPoint: 'Retira el pedido cuando veas tu número en pantalla',
        mop: 'Anúnciate con tu número',
        aut: 'Comparte este código para que empecemos a preparar tu pedido',
      },
    },
    buttons: {
      onGoing: 'En curso',
      finished: 'Finalizado',
      cancelOrder: 'Cancelar pedido',
      pay: 'Pagar',
      reorder: 'Repetir pedido',
      rate: 'Calificar',
      arrival: 'Llegué',
      track: 'Seguir pedido',
      receive: 'Recibir mi pedido',
    },
    toast: {
      orderCanceled: 'Pedido cancelado',
      orderCanceledError: 'El pedido no pudo ser cancelado',
      orderCanceledMOP: 'El pedido está siendo preparado y no es posible cancelarlo',
      orderCanceledDLV: 'El repartidor ya esta en camino a tu domicilio y no es posible cancelarlo',
      orderUnappliedProducts:
        'La promoción fue añadida, pero no aplica a los productos de tu pedido',
    },
    messages: {
      yappy:
        'Si tienes dudas sobre tu pedido realizado con Yappy, contáctanos a través de nuestro chat',
      flexCancelledReason: {
        title: 'Pedido cancelado',
        knowMore: 'Saber más',
        type: {
          FLEX_CANCELLED_REFUND:
            'Ocurrió un problema pero, ¡no te preocupes! Recibirás el reembolso en {min} o {max} días hábiles',
          FLEX_CANCELLED_ERR_ADDRESS:
            'Hubo un problema con la dirección de envío. El dinero no podrá ser reembolsado. Disculpa las molestias.',
          FLEX_CANCELLED_ERR_INFO: 'Tu pedido ha sido cancelado, te pedimos disculpas',
        },
      },
      refundType: {
        TOTAL_REFUNDED_MONEY:
          'El tiempo de devolución del dinero puede variar según el banco o el medio de pago utilizado.',
        TOTAL_REFUNDED_LOYALTY:
          'Ya te devolvimos los puntos del producto por el que hiciste el reclamo.',
        TOTAL_REFUNDED_ALL:
          'Ya te devolvimos los puntos del producto por el que hiciste el reclamo. El tiempo de devolución del dinero puede variar según tu banco o medio de pago.',
        TOTAL_REFUNDED_VOUCHER:
          'Ya te devolvimos los puntos del producto por el que hiciste el reclamo. El tiempo de devolución del dinero puede variar según tu banco o medio de pago.',
        PARTIAL_REFUNDED_MONEY:
          'El tiempo de devolución del dinero puede variar según el banco o el medio de pago utilizado.',
        PARTIAL_REFUNDED_LOYALTY:
          'Ya te devolvimos los puntos del producto por el que hiciste el reclamo.',
        PARTIAL_REFUNDED_ALL:
          'Ya te devolvimos los puntos del producto por el que hiciste el reclamo. El tiempo de devolución del dinero puede variar según tu banco o medio de pago.',
        PARTIAL_REFUNDED_VOUCHER:
          'Ya te devolvimos los puntos del producto por el que hiciste el reclamo. El tiempo de devolución del dinero puede variar según tu banco o medio de pago.',
      },
    },
    alert: {
      receiveOrder: {
        title: 'Estamos listos para preparar tu pedido',
        body: 'Recuerda que es importante estar en la dirección que elegiste para recibir tu pedido. ¿Ya estás en <b>{address}</b> para recibirlo?',
        accept: 'Confirmar',
        cancel: 'Todavía no',
      },
    },
    receiveOrder: {
      texts: {
        'no-riders': {
          title: 'Lo sentimos, no encontramos repartidores disponibles para tu pedido',
          body: 'Estamos trabajando para resolverlo a la brevedad. Intenta solicitar el envío de nuevo en unos minutos.',
        },
        'no-stock': {
          title: 'Lo sentimos, no pudimos empezar tu pedido por falta de ingredientes',
          body: 'Estamos trabajando para resolverlo cuanto antes. Intenta solicitar el envío de nuevo en unos minutos.',
        },
        'rest-closed': {
          title: 'En este momento el restaurante está cerrado',
          body: 'Para que puedas recibir tu pedido, asegurate de solicitar el envío en nuestros horarios de atención.',
        },
        'generic': {
          title: 'Lo sentimos, algo ha fallado y no hemos podido empezar tu pedido',
          body: 'Estamos trabajando para resolverlo a la brevedad. Intenta solicitar el envío de nuevo o espera unos minutos para volver a reintentarlo.',
        },
      },
      actions: {
        primary: 'Intentar más tarde',
        secondary: 'Ir a mi pedido',
      },
    },
  },

  SEO: {
    restaurants: {
      title: "Encuentra tu local McDonald's más cercano",
      description:
        "Encuentra el restaurante McDonald's más cercano, estés donde estés {'|'} Horarios, direcciones y menús para que disfrutes de tus favoritos: delivery o {pickup}.",
      city: {
        title: "Encuentra tu local McDonald's más cercano en {city}",
        description:
          "Descubre el restaurante McDonald's más cercano de {city}. Tu hamburguesa favorita cerca de ti {'|'} Horarios, direcciones y menús.",
        restaurant: {
          title: '{restaurant} {city}: Descubre nuestras ofertas',
          description: `Haz que te entreguen tus favoritos de McDonald's estés donde estés. Pide a domicilio tu comida favorita con {restaurant} {city} al mejor precio✓.`,
          orders: {
            title: `Mis pedidos en {restaurant} {'|'} McDonald's`,
            description: `Pide en {restaurant} en {city} {'|'} Explora nuestro menú y disfruta de la comodidad de la entrega a domicilio o la recogida en el restaurante.`,
            area: {
              title: `⇨{area} McDonald's {city}`,
              description: `Encuentra y personaliza el menú que más te gusta con guarnición a elegir, patatas y bebida. Elige el tamaño y pide en McDonald's al mejor precio✓.`,
              category: {
                title: `Pedir {category} {restaurant}`,
                description: `Ahora tu pedido McDonald's más cerca que nunca. Escoge tu {category} disponible para delivery o {pickup} en {restaurant}.`,
                product: {
                  title: `Pedir {product} {restaurant}`,
                  description: `Ahora tu pedido McDonald's más cerca que nunca. Disfruta de {product} disponible para delivery o {pickup} en {restaurant}.`,
                },
              },
            },
          },
        },
      },
    },
    menu: {
      title: `Menú McDonald's - Todos los productos`,
      description: `Encuentra y personaliza el menú que más te gusta con guarnición a elegir, patatas y bebida. Elige el tamaño y pide en McDonald's al mejor precio✓.`,
      category: {
        title: `{category} McDonald's {'|'} Completa tu menú`,
        description: `¿Tienes hambre? En McDonald's disponemos de diferentes ofertas de {category} en McDonald's para recoger o pedir a domicilio al mejor precio ✓. Escoge tu menú favorito.`,
        product: {
          title: `{product} - {category} {'|'} McDonald's`,
          description: `Disfruta de tu {product}, delivery o {pickup}. 24h en tu McDonald's más cercano ✓ Descubre nuestras novedades y ofertas en la web oficial.`,
        },
      },
    },

    orders: {
      cart: {
        title: `Revisa y Completa tus Pedidos {'|'} McDonald's`,
        description: `Completa tu pedido en McDonald's {'|'} Encuentra los productos que deseas y procede al pago online de forma fácil y segura{'|'} ¡A disfrutar!`,
      },
      cartProductIndex: {
        title: `Revisa y Completa tus Pedidos {'|'} McDonald's`,
        description: `Revisa tu pedido, puedes completarlo o editarlo de forma fácil | Encuentra los productos que deseas y procede al pago online de forma fácil y segura {'|'} ¡A disfrutar!`,
      },
      checkout: {
        title: `Checkout {'|'} McDonald's`,
        description: `Completa tu pedido. {'|'} Revisa tu selección e ingresa tus datos ¡listo para disfrutar de una comida deliciosa! Pago seguro✓`,
      },
    },

    my: {
      account: {
        title: `Mis datos personales {'|'} McDonald's`,
        description: `Gestiona tus datos personales de forma fácil y segura en McDonald's {'|'} Actualiza información de perfil, dirección y favoritos {'|'} Mantén tu cuenta al día.`,
        section: {
          title: `{section} {'|'} McDonald's`,
          description: `Gestiona tus datos personales de forma fácil y segura en McDonald's {'|'} Actualiza información de perfil, dirección y favoritos {'|'} Mantén tu cuenta al día.`,
        },
        my: {
          orders: {
            title: `Mis pedidos {'|'} McDonald's`,
            description: `Consulta tus pedidos, historial de compras y detalles de tus órdenes anteriores {'|'} Realiza un seguimiento de tus entregas y realiza un nuevo pedido si lo deseas.`,
            orderId: {
              title: `{orderId} {'|'} McDonald's`,
              description: `Consulta los detalles de tu pedido {orderId} {'|'} Información detallada de tu compra, estado de entrega y productos adquiridos en McDonald's.`,
            },
          },
        },
      },
    },
  },
  phone: {
    phoneValidation: {
      title: 'Número de teléfono',
      subtitle:
        'Con el fin de asegurar que solo tú tengas acceso a tu cuenta, por favor ingresa tu número de teléfono.',
      continue: 'Validar y guardar',
      duplicatePhone: 'El número de teléfono ya está registrado, por favor ingresa uno diferente',
    },
    phoneVerification: {
      title: 'Validar tu teléfono',
      subtitle: 'Acabamos de enviarte el código de validación de seis dígitos a tu teléfono',
      notSended: '¿No te llega el código?',
      notSendedDisclaimerCountdown: 'Puedes solicitarlo nuevamente en {time}.',
      notSendedDisclaimer: 'Puedes solicitarlo nuevamente ahora.',
      sendAgain: 'Enviar código de nuevo',
      errorCode: {
        CODE_FIELD_ERROR: 'Código erróneo',
        CODE_FIELD_ERROR_EXPIRED:
          'El código ha expirado.<br/>Para validar tu teléfono pulsa en “enviar código de nuevo”',
      },
    },
    alert: {
      phoneAlreadyValidated: {
        title: 'Lo sentimos, ha habido un error en el proceso',
        body: 'Por favor, inténtalo de nuevo',
        accept: 'Continuar',
      },
    },
    toast: {
      generic: 'Lo sentimos, ha habido un error. Por favor, inténtalo de nuevo',
      warning: 'Por favor, espera {time} antes de volver a solicitar un código nuevo',
      success: 'Teléfono verificado',
    },
    block: {
      title: 'Límite de envíos superados',
      subtitle: 'No pudimos validar tu teléfono debido a un exceso de envíos.',
      tryAgainCountdown: 'Por favor, inténtalo nuevamente en {time}.',
      tryAgainNow: 'Por favor, inténtalo nuevamente ahora.',
      action: 'Volver a la home',
    },
  },
  device: {
    deviceVerification: {
      title: 'Valida tu dispositivo',
      subtitle:
        'Acabamos de enviarte el <b>código de validación de cuatro dígitos</b> a tu correo {email}, ingrésalo para continuar tu pedido.',
      notSended: '¿No te llega el código?',
      notSendedDisclaimerCountdown:
        'Recuerda revisar tu carpeta de spam. Puedes solicitarlo nuevamente en {time}.',
      notSendedDisclaimer:
        'Recuerda revisar tu carpeta de spam. Puedes solicitarlo nuevamente ahora.',
      sendAgain: 'Enviar código de nuevo',
      errorCode: {
        CODE_FIELD_ERROR: 'Código erróneo',
        CODE_FIELD_ERROR_EXPIRED:
          'El código ha expirado.<br/>Para validar tu dispositivo pulsa en “enviar código de nuevo”',
      },
    },
    alert: {
      deviceAlreadyValidated: {
        title: 'Lo sentimos, ha habido un error en el proceso',
        body: 'Por favor, inténtalo de nuevo',
        accept: 'Continuar',
      },
    },
    toast: {
      generic: 'Lo sentimos, ha habido un error. Por favor, inténtalo de nuevo',
      success: 'Dispositivo validado con éxito ',
    },
    block: {
      title: 'Límite de envíos superados',
      subtitle: 'No pudimos validar tu dispositivo debido a un exceso de envíos.',
      tryAgainCountdown: 'Por favor, inténtalo nuevamente en {time}.',
      tryAgainNow: 'Por favor, inténtalo nuevamente ahora.',
      action: 'Volver a la home',
    },
  },
  email: {
    emailVerification: {
      title: 'Revisa tu correo electrónico',
      subtitle:
        'Acabamos de enviarte el <b>código de validación de cuatro dígitos</b> a tu correo {email}, ingrésalo para continuar tu pedido.',
      notSended: '¿No te llega el código?',
      notSendedDisclaimerCountdown:
        'Recuerda revisar tu carpeta de spam. Puedes solicitarlo nuevamente en {time}.',
      notSendedDisclaimer:
        'Recuerda revisar tu carpeta de spam. Puedes solicitarlo nuevamente ahora.',
      sendAgain: 'Enviar código de nuevo',
      errorCode: {
        CODE_FIELD_ERROR: 'Código erróneo',
        CODE_FIELD_ERROR_EXPIRED:
          'El código ha expirado.<br/>Para validar tu email pulsa en “enviar código de nuevo”',
      },
    },
    alert: {
      emailAlreadyValidated: {
        title: 'Lo sentimos, ha habido un error en el proceso',
        body: 'Por favor, inténtalo de nuevo',
        accept: 'Continuar',
      },
      validationInProgress: {
        title: '¿Estás seguro de que quieres volver?',
        body: 'Recuerda que al hacerlo, podrías perder los datos que has ingresado hasta ahora.',
        accept: 'Volver atrás',
        cancel: 'Cancelar',
      },
    },
    toast: {
      generic: 'Lo sentimos, ha habido un error. Por favor, inténtalo de nuevo',
      success: 'Datos guardados con éxito',
      successAlt: 'Correo confirmado con éxito',
    },
    block: {
      title: 'Límite de envíos superados',
      subtitle: 'No pudimos validar tu email debido a un exceso de envíos.',
      tryAgainCountdown: 'Por favor, inténtalo nuevamente en {time}.',
      tryAgainNow: 'Por favor, inténtalo nuevamente ahora.',
      action: 'Volver a la home',
    },
  },
  requiredFields: {
    title: 'Completa tus datos',
    subtitle:
      'Ingresa los datos que faltan para poder continuar con tu compra. Estos datos serán guardados de manera segura y no te los volveremos a solicitar.',
    actions: {
      continue: 'Continuar',
    },
    alerts: {
      genericError: {
        title: 'Lo sentimos, ha habido un error en el proceso',
        body: 'Por favor, inténtalo de nuevo',
        accept: 'OK',
      },
      duplicatePhone: {
        title: 'Teléfono ya registrado',
        body: 'El número de teléfono ya está registrado, por favor ingresa uno diferente',
        accept: 'OK',
      },
    },
  },
  repeatOrder: {
    success: {
      title: '¿Estás seguro de que quieres repetir este pedido?',
      body: 'La orden se creará en el mismo restaurante donde realizaste el pedido. Si tienes productos en tu carrito serán sustituidos por los productos de esta compra. Los precios de los productos pueden haber variado.',
      accept: 'Continuar',
      cancel: 'Cancelar',
    },
    genericError: {
      title: '¡Ups! En este momento no será posible repetir el pedido',
      body: 'Mientras tanto, echa un vistazo a nuestro catálogo o inténtalo de nuevo',
      accept: 'Intentar de nuevo',
      cancel: 'Ver Catálogo',
    },
    noRiders: {
      title: 'Lo sentimos, en estos momentos no hay repartidores disponibles en tu zona',
      body: 'Estamos con alta demanda de pedidos. Por favor, vuelve a intentarlo en unos minutos.',
      accept: 'Aceptar',
      cancel: '',
    },
    mopNotAvailable: {
      title: 'Ups! No será posible repetir el pedido',
      body: 'En este momento este restaurante no tiene disponible {pickup}. Vuelve a intentarlo en unos minutos.',
      accept: 'Aceptar',
      cancel: '',
    },
    dlvNotAvailable: {
      title: 'Ups! No será posible repetir el pedido',
      body: 'En este momento este restaurante no tiene disponible McDelivery. Vuelve a intentarlo en unos minutos.',
      accept: 'Aceptar',
      cancel: '',
    },
    restaurantNotFound: {
      title: 'Oh no, no hemos podido encontrar tu restaurante.',
      body: 'Te recomendamos que intentes hacer un nuevo pedido en otro restaurante',
      accept: 'Entendido',
      cancel: '',
    },
    closedRestaurant: {
      title: 'Ahora mismo nuestro local se encuentra cerrado',
      body: 'No será posible repetir este pedido. Te sugerimos que elijas otro restaurante para hacer tu compra.',
      accept: 'Entendido',
      cancel: '',
    },
    permittedAreasProducts: {
      title: 'Oh no, este pedido ya no se encuentra disponible',
      body: 'Algunos de los productos de este pedido no se pueden retirar por ninguno de los métodos de retiro disponibles',
      accept: 'Entendido',
      cancel: '',
    },
    outOfDaypartProducts: {
      title: '¡Ups! En este momento no será posible repetir el pedido',
      body: 'Algunos productos no están dentro de su horario de preparación. Por favor, intente repetir otro pedido, o inicie una nueva compra.',
      accept: 'Entendido',
      cancel: '',
    },
    notExistingProducts: {
      title: '¡Ups! En este momento no será posible repetir el pedido',
      body: 'Algunos productos de esta compra ya no son parte del catálogo. Por favor, intente repetir otro pedido, o inicie una nueva compra.',
      accept: 'Entendido',
      cancel: '',
    },
  },
  contact: {
    title: 'Completa el formulario con tus datos',
    inputs: {
      firstname: 'Nombre',
      lastname: 'Apellidos ',
      email: 'Email',
      phone: 'Teléfono',
      city: 'Ciudad',
      local: 'Restaurante',
      date: 'Día',
      time: 'Hora',
      message: 'Mensaje',
      newsletterAccepted:
        'Acepto recibir información sobre las novedades y promociones de McDonald’s',
      subject: {
        label: 'Motivo',
        placeholder: 'Elige uno',
        option: {
          suggestion: 'Sugerencia',
          inquire: 'Consulta',
          openDoors: 'Puertas abiertas',
          criticism: 'Crítica',
          claim: 'Reclamo',
          praise: 'Elogio',
          personalData: 'Datos personales',
          other: 'Otros',
        },
      },
    },
    toast: {
      error: 'Lo sentimos, ha ocurrido un error inesperado. Vuelve a intentarlo más tarde',
      success: 'El formulario de contacto se ha enviado con éxito',
    },
    action: {
      save: 'Guardar',
    },
  },
  rating: {
    stars: {
      help: 'Elija de 1 a 5 estrellas para evaluar su pedido',
      new: {
        title: '¿Cómo fue tu experiencia con este pedido?',
      },
      edit: {
        title: '¿Continuar evaluando el último pedido?',
        actions: {
          notNow: 'Ahora no',
          continue: 'Continuar',
        },
      },
    },
    form: {
      rate: 'Valora tu satisfacción con:',
      anyProblem: '¿Tuvo algún problema con el pedido?',
      send: 'Enviar',
    },
    finalStep: {
      title: "¡Gracias por elegir McDonald's!",
      ok: {
        subtitle:
          "Valoramos tu opinión y queremos asegurarnos de que tu experiencia en McDonald's sea la mejor posible.",
      },
      ko: {
        subtitle: "Queremos asegurarnos de que tu experiencia en McDonald's sea la mejor posible.",
        subtitle2:
          'Si tienes alguna duda o necesitas asistencia, ponte en contacto con nuestro centro de atención al cliente. ¡Estamos aquí para ayudarte!',
      },
    },
    toasts: {
      NOT_FOUND: 'Lo sentimos, no hemos encontrado el pedido',
      ALREADY_RATED: 'Este pedido ya ha sido valorado',
      RATING_EXPIRED: 'Lo sentimos, el tiempo para valorar este pedido ha finalizado',
      UNKNOWN: 'Lo sentimos, ocurrió un error inesperado. Por favor, inténtelo de nuevo mas tarde',
    },
    unavailable: {
      title: 'Esta encuesta ya no está disponible.',
      subtitle:
        'Es posible que ya la hayas respondido o que el plazo para participar haya finalizado.',
      thanks: 'Gracias por ayudarnos a mejorar tu experiencia.',
    },
  },
  overrideRestaurant: {
    autoselectRestaurantAndArea: {
      title: '¿Está seguro que desea cambiar el restaurante?',
      body: 'Si desea continuar, se procederá a eliminar los productos del carrito actual',
      accept: 'Continuar',
      cancel: 'Cancelar',
    },
    autoselectRestaurantAndAreaError: {
      title: 'Ha ocurrido un error al seleccionar el restaurante',
      body: 'El restaurante seleccionado no está disponible. Lo sentimos, inténtalo de nuevo más tarde',
      accept: 'Continuar',
      cancel: 'Cancelar',
    },
  },
  redirection: {
    error: {
      title: 'Algo ha fallado',
      fallbackLink: 'Haga click aquí para continuar',
    },
  },
  enrollment: {
    BirthDate: {
      title: 'Fecha de nacimiento',
      body: 'Es necesario completar tu fecha de nacimiento para poder comprobar que nuestros usuarios tienen la edad mínima requerida para utilizar la aplicación',
      dateLabel: 'Fecha de nacimiento',
    },
    Name: {
      title: 'Nombre y apellido',
      body: '¿Cómo te gustaría que te llamemos?',
      label: {
        name: 'Nombre',
        lastName: 'Apellido',
      },
    },
    Document: {
      title: 'Documento de identidad',
      body: 'Introduce tu número de identidad. De esta manera podremos garantizar la seguridad de tu información',
      labelCpfType: 'Tipo documento',
      dropdownPlaceholder: 'Elige uno',
      documentLabel: 'Nº del documento',
      optInCpfLabel:
        'Acepto que McDonald’s utilice mi número de CPF, también indicado en mis compras en los restaurantes McDonald’s, para ofrecerme productos, servicios y ofertas personalizadas, de acuerdo con la',
      warningTitle: 'Consulta más información',
      warningBody: 'Atención al cliente',
      warning: {
        title: 'Documento ya registrado',
        body: 'Este número de documento ya está registrado para el email {email}. Para más información, ponte en contacto con ',
        link: 'Atención al cliente',
      },
      modal: {
        title: 'Este número ya fue registrado con el correo [{email}]',
        subtitle: {
          text: '¿Qué puedes hacer?',
          option1: 'Ingresa con ese correo si tienes acceso',
          option2: 'Recupera tu contraseña si no la recuerdas',
          option3: 'Contáctanos si ya no tienes acceso a ese correo',
        },
        needHelp: 'Necesito ayuda',
        recoverPassword: 'Recuperar contraseña',
        loginWithThisEmail: 'Ingresar con este correo',
      },
    },
    Phone: {
      title: 'Número de teléfono',
      body: 'Con el fin de asegurar que solo tú tengas acceso a tu cuenta, por favor ingresa tu número de teléfono',
      label: {
        prefix: 'Prefijo',
        number: 'Número',
      },
    },
  },
  vouchers: {
    minecraft: {
      title: 'Tienes disponibles',
      description: 'Puedes obtener un código Minecraft si tienes los puntos necesarios',
      redeemCoupon: {
        title: '¿Quieres canjear <br/><b>{value} pts.</b> para obtener <br/>un código?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabas de obtener tu código Minecraft',
        useCodeInfo: '¿Cómo usar los códigos?',
        codeExpiration: 'Tu código vence el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos minecraft',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title: 'Solo se permite activar un código por cuenta Minecraft',
        description:
          "Canjea tus puntos desde el { startDate } al { endDate } o hasta agotar el stock de { stock } unidades. El código activa 25 complementos (Add-ons) de McDonald's en Minecraft: Bedrock Edition { linkTerms }",
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Inténtalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos Minecraft',
        noPointsAvailable: {
          title:
            'No tienes los puntos necesarios para obtener un código. Necesitas { value } pts. para conseguirlo',
          description: 'Puedes obtener un código Minecraft si tienes los puntos necesarios',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste en la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
    ticketbox: {
      title: 'Tienes disponibles',
      description: 'Activa el código y sigue las instrucciones para obtener tu entrada de cine',
      redeemCoupon: {
        title: '¿Quieres canjear <br/><b>{value} pts.</b> para obtener un código <br/> McDonald´s?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabas de obtener un código McDonald´s',
        useCodeInfo: '¿Cómo activo el código?',
        codeExpiration: 'Tu código McDonald´s vence el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title:
          'Puedes activar el código McDonald´s en TicketBox y seguir las instrucciones para obtener tu entrada a la función de cine 2D',
        description:
          'Canje de puntos válido a través de la App de <br/> McDonald´s Argentina desde el { startDate } hasta el { endDate } o hasta agotar el stock de { stock } códigos McDonald´s. { linkTerms }',
        acceptTermsNotice: {
          title: 'Al realizar el canje, aceptas las',
          link: {
            label: 'Bases y Condiciones',
            url: 'https://www.mcdonalds.com.ar/terminos-y-condiciones-mimcine',
          },
        },
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Inténtalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos de cine',
        noPointsAvailable: {
          title: '¡Estás cerca de tu código McDonald´s!',
          description: 'Necesitas 1500 puntos para obtenerlo ¡Sigue sumando!',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste en la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
    paddockf1: {
      title: 'Tienes disponibles',
      description:
        'Si haces clic en "Volver", podrás canjear una nueva chance y visualizar todas las que ya canjeaste',
      redeemCoupon: {
        title: '¿Quieres canjear <br/><b>{value} pts.</b> para obtener una chance?',
        accept: 'Quiero obtener una chance',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabas de obtener un chance',
        description:
          'El código será utilizado para el sorteo. Tu chance está asociada al código a continuación',
        useCodeInfo: '¿Tienes dudas?',
        codeExpiration: 'El sorteo será realizado el',
        accept: 'Volver',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title:
          '¡Suma todas las chances que quieras y participa del sorteo por un par de entradas para el exclusivo Paddock Club™ México!',
        description:
          'Promoción válida desde el { startDate } hasta el { endDate } inclusive, únicamente mediante la aplicación McDonald’s Costa Rica. Por cada { stock } puntos canjea 1 chance para participar del sorteo. Utilizando el código “MCDF1” en tus compras acumulas una chance más. Consulta las { linkTerms }',
        acceptTermsNotice: {
          title: 'Al obtener una entrada, aceptas las',
          link: {
            label: 'Bases y Condiciones.',
            url: 'https://www.mcdonalds.co.cr/bases-y-condiciones-paddock2025',
          },
        },
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Inténtalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de chances',
        noPointsAvailable: {
          title: '¡Estás cerca de obtener un chance!',
          description: 'Necesitás 40 puntos para obtenerlo ¡Sigue sumando!',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste en la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
    trophytour: {
      title: 'Tienes disponibles',
      description:
        'Accede al sitio web de Coca-Cola, loguéate para obtener tu entrada y elegir el día y el horario disponibles.',
      redeemCoupon: {
        title: '¿Quieres canjear <br/><b>{value} pts.</b> para obtener un código?',
        accept: 'Quiero obtener un código',
        cancel: 'Ahora no',
      },
      appliedCoupon: {
        title: '¡Felicitaciones! Acabas de obtener un código',
        description:
          'Accede al sitio web de Coca-Cola, loguéate para obtener tu entrada y elegir el día y el horario disponibles.',
        useCodeInfo: '¿Cómo activo el código?',
        codeExpiration: 'Tu código vence el',
        accept: 'Volver',
        termsLinks:
          'https://www.coca-cola.com/ar/es/offerings/copa-mundial-de-la-fifa-2026/trophy-tour-partner',
      },
      codeList: {
        title: 'Ver mis códigos obtenidos',
        titleMinecraft: 'Mis códigos',
        description: 'Códigos',
        code: 'Código',
        expiration: 'Caducidad',
      },
      notification: {
        title:
          'Podrás activar tu código en el sitio web de Coca-Cola para obtener una entrada al evento FIFA World Cup Trophy Tour by Coca-Cola, que se realizará en Av. Sarmiento 2704, C1425 Ciudad Autónoma de Buenos Aires, Argentina el 19 y 20 de febrero de 2026.',
        description:
          'Canje de puntos válido a través de la App McDonald’s Argentina desde el { startDate } al { endDate } o hasta agotar el stock de { stock } códigos.',
        acceptTermsNotice: {
          title:
            'Al activar el código, podrás seleccionar solo un día y un horario disponible en el sitio web. Al realizar el canje, aceptas las',
          link: {
            label: 'Bases y Condiciones.',
            url: 'https://cloud.news.mcdonalds.com.ar/TyCs_Trophy_Tour',
          },
        },
      },
      errors: {
        generic: 'Algo no salió como esperábamos. Inténtalo de nuevo más tarde',
        maximumPurchasesExceeded: 'Superaste el número máximo de compras de códigos',
        noPointsAvailable: {
          title: '¡Estás cerca de obtener un código!',
          description: 'Necesitás 750 puntos para obtenerlo ¡Sigue sumando!',
        },
      },
      emptyVoucherList: {
        description:
          'Parece que no participaste en la promoción, por eso no podemos mostrar ningún código',
        accept: 'Volver',
      },
    },
  },
  offers: {
    title: '¡Accede a este cupón descargando nuestra app!',
    description: 'Aprovecha beneficios únicos y ofertas todos los días desde tu celular',
  },
  stepsReference: 'Paso {current} de {total}',
  cancellationPolicy: {
    titleClose: 'Detalle del pedido',
    title: 'Política de Cancelación',
    subtext:
      'Lamentablemente pueden ocurrir imprevistos y puede ser que necesites cancelar tu pedido. A continuación, se presentan los casos en los que la cancelación puede realizarse directamente desde la app de Mc Donald’s y otras indicaciones:',
    first: {
      title: 'Pedido realizado por Pide y Retira',
      text1:
        "Puedes solicitar la cancelación antes de confirmar que estás en el restaurante y de que el pedido sea enviado a prepararse. En el caso de que el pedido haya sido realizado por canje de puntos Mi McDonald 's, los puntos serán devueltos automáticamente.",
      text2:
        'Si enviaste un pedido a preparar y tuviste algún imprevisto, por favor entra en contacto con nuestro SAC, por medio de los canales disponibles en la app de McDonald’s - teléfono: {phone}  WhatsApp: {whatsApp} y e-mail: ',
    },
    second: {
      title: 'Pedido realizado por Delivery',
      text1:
        'Después de la confirmación del pedido por medio de la app, comenzará la preparación y el pedido no podrá ser cancelado o modificado.',
      text2:
        'Si después de la entrega del pedido tienes alguna duda, crítica o sugerencia, por favor ponte en contacto con nuestro SAC.',
      text3:
        'Si tu pedido no ha sido entregado y por alguna razón todavía no fue cancelado, por favor, ponte en contacto con nuestro SAC.',
    },
    important: {
      title: 'AVISO IMPORTANTE',
      text1:
        'Para finalizar el pedido, el repartidor SIEMPRE solicitará un código de validación de entrega.',
      text2:
        'No informes el código antes de recibir el pedido. Si informaste el código antes de tener el pedido en mano, y por alguna razón no lo recibiste, el reembolso no será realizado.',
      text3:
        'En el caso  de que tu pedido sea cancelado, no te preocupes, solicitaremos el reembolso del valor del pedido automáticamente. El tiempo estimado para el reembolso puede variar de acuerdo a la modalidad de pago, como se detalle a continuación:',
      listItem1:
        'Para compras realizadas con débito, el reembolso se efectuará en: Hasta 7 días hábiles a partir de la fecha de cancelación.',
      listItem2:
        'Para compras realizadas con crédito, el reembolso se efectuará en: Hasta 30 días hábiles a partir de la fecha de cancelación y de acuerdo con la fecha de cierre de la factura del cliente.',
      listItem3:
        'Para compras realizadas con Mercado Pago el reembolso se efectuará en: Hasta 2  días hábiles a partir de la fecha de cancelación.',
      listItem4:
        'Si ocurre algún otro problema, para que podamos evaluar tu solicitud, por favor no dudes en contactarnos a través de los siguientes canales:',
      listItem5: '',
      listItem6: '',
      listItem7: '',
      lastText: '',
      phone: 'Teléfono: {phone}',
      whatsApp: 'WhatsApp: {whatsApp}',
      email: 'E-mail:',
    },
  },
  refundPolicy: {
    title: 'Política de reembolso',
    important: {
      listItem1:
        'Para compras realizadas con débito, el reembolso se realizará en hasta 7 días hábiles a partir de la fecha de cancelación.',
      listItem2:
        'Para compras realizadas con crédito, el reembolso se realizará en hasta 30 días hábiles a partir de la fecha de cancelación y de acuerdo con la fecha de cierre de la factura del cliente.',
      listItem3:
        'Para compras realizadas con vales, el reembolso se realizará en hasta 7 días hábiles a partir de la fecha de cancelación.',
      listItem4:
        'Para compras realizadas con Gift Card, el reembolso se realizará en hasta 2 días hábiles a partir de la fecha de cancelación.',
      listItem5:
        'Para compras realizadas con Mercado Pago, el reembolso se realizará en hasta 2 días hábiles a partir de la fecha de cancelación.',
      listItem6:
        'Para compras realizadas con Sem Parar, el reembolso se realizará en hasta 2 días hábiles a partir de la fecha de cancelación.',
      listItem7:
        'Para compras realizadas con PIX, el reembolso se realizará en hasta 2 días hábiles a partir de la fecha de cancelación.',
      listItem8:
        'Para compras realizadas con puntos Mi McDonald’s, el reembolso se hace de forma inmediata después de la cancelación.',
    },
  },
  markdown: {
    vouchers: {
      minecraft: {
        terms: termsES,
      },
      ticketbox: {
        terms: termsTicketboxES,
      },
      paddockf1: {
        terms: termsPaddockES,
      },
    },
  },
  bubble: {
    upselling: 'Solo por',
  },
  loyalty: {
    title: 'Suma puntos con { programName } y cámbialos por recompensas. <br/> ¡Descarga la app!',
    description: 'Ahorra con puntos, aprovecha promociones y cupones pensados para ti',
    link: 'Saber más sobre { programName }',
    name: 'Mi McDonald’s',
  },
  mandatoryTerms: {
    default: 'Términos y condiciones de uso',
    title: 'Acepta los Términos y Condiciones para continuar',
    subtitle:
      'Necesitas leer y aceptar los Términos y Condiciones para seguir usando nuestras plataformas',
    action: 'Aceptar y continuar',
  },
  birthdayLanding: {
    title: '¡Reserva tu cumpleaños en McDonald’s directo desde la App!',
    subtitle:
      'Celebrar su día nunca fue tan fácil: descarga la App y reserva un cumple inolvidable en pocos pasos.',
  },
}
